import { render, staticRenderFns } from "./DoctorFormEdit.vue?vue&type=template&id=41bff747&scoped=true"
import script from "./DoctorFormEdit.vue?vue&type=script&lang=js"
export * from "./DoctorFormEdit.vue?vue&type=script&lang=js"
import style0 from "./DoctorFormEdit.vue?vue&type=style&index=0&id=41bff747&prod&scoped=true&lang=css"
import style1 from "./DoctorFormEdit.vue?vue&type=style&index=1&id=41bff747&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41bff747",
  null
  
)

export default component.exports